class MemberList {
	constructor(container) {
		this._container = ge(container);
		this._members = [];
		this._activeMember = null;
		this.inviteId = null;

		this.inviteDialog = Dialog.Modal('invite-member', _("Invite new member"), X_LARGE, _("SEND INVITE"));
		this.inviteDialog.head = div(null, [
			this.searchName = text(null, null, null, {'placeholder': _("Heroes username or email"), 'size': 30}),
			this.searchBtn = btn('btn', _("Search"))
		]);
		this.inviteDialog.affirmButton.disabled = true;

		this.instructions = div(null, [
			p(null, _("Search for heroes and send them an invite to join this community"))
		]);
		this.notFound = div(null,htm('h4', null, _("No hero found with those details!")))
		this.messageInput = div(null, [
		htm('h4', null, _("The hero was found")),
			p(null, [_("Invite them as a "), this.memberType = htm('select', null, [
				option(_("Associate"), AC.MEMBER_ASSOCIATE),
				option(_("Contributor"), AC.MEMBER_CONTRIBUTOR),
				option(_("Manager"), AC.MEMBER_MANAGER)
			])]),
			htm('hr'),
			p(null, _("You can include a message with the invitation, this may be helpful for the hero to know where the invite came from.")),
			p(null, label(null, [
				_("Message"), '<br/>',
				this.messageText = area()
			]))
		]);

		this._typePopup = Dialog.Popup('member-type', [
			btn('popup-list-btn', _("Manager"), {'click':this.setType.bind(this, AC.MEMBER_MANAGER)}),
			btn('popup-list-btn', _("Contributor"), {'click':this.setType.bind(this, AC.MEMBER_CONTRIBUTOR)}),
			btn('popup-list-btn', _("Associate"), {'click':this.setType.bind(this, AC.MEMBER_ASSOCIATE)})
		]);

		onEv(this.searchName, 'keyup', (event) => {
			stopEv(event);
			if (event.keyCode === AC.ENTER_KEY) {
				this.searchNewMember();
			}
			else {
				this.searchBtn.disabled = this.searchName.value.length == 0;
			}
		});
		
		onEv(this.searchName, 'paste', (event) => {
			this.searchBtn.disabled = event.clipboardData.getData('text').length == 0;
		});
		
		onEv(this.searchBtn, 'click', this.searchNewMember.bind(this));
		onEv('inviteMemberBtn', 'click', this.inviteMember.bind(this));

		this.getList();
	}

	getList() {
		ajg('member/list', null, null, (reply) => {
			this._members = [];
			this._container.innerHTML = '';
			if (showError(reply)) return;
			if (reply.members && Array.isArray(reply.members)) {
				reply.members.forEach((data) => {
					let member = Member.fromArray(data, this);
					this._members.push(member);
					this._container.appendChild(member.elem);
				});
				document.dispatchEvent(new Event('primaryDataLoaded'));
			}
		});
	}

	inviteMember() {
		this.inviteDialog.clear().body = this.instructions;
		this.inviteDialog.open(this.sendInvite.bind(this));
		this.searchName.value = '';
		this.searchName.focus();
		this.searchBtn.disabled = true;
	}

	searchNewMember() {
		ajp('member/find', [
			'str=' + encodeURI(this.searchName.value)
		], null, (reply) => {
			if (showError(reply)) return;
			if (reply.success) {
				this.inviteDialog.clear().body = this.messageInput;
				this.memberType.value = AC.MEMBER_ASSOCIATE;
				this.inviteDialog.affirmButton.disabled = false;
				this.inviteId = reply.userId;
			}
			else {
				this.inviteDialog.clear().body = this.notFound;
				this.inviteDialog.affirmButton.disabled = true;
				this.inviteId = null;
			}
		}, this);
	}

	sendInvite() {
		if (this.inviteId == null) return;
		ajp('member/invite', [
			'id=' + this.inviteId,
			'type=' + this.memberType.value,
			'message=' + encodeURI(this.messageText.value)
		], null, (reply) => {
			if (showError(reply)) return;
			if (reply.success) {
				makeToast(_("Invite sent!"));
			}
		}, this);
	}

	selectType(member) {
		this._activeMember = member;
		this._typePopup.handle(member.typeButton);
	}

	setType(type) {
		if (this._activeMember === null) return;
		this._activeMember.setType(type);
	}

	allocateLicence(member) {
		
	}
}